import { setLocale } from 'yup';

import { formatDate } from '~app/dayjs';
import { pluralize } from '~app/utils/transformers/pluralize';

setLocale({
  mixed: {
    required: 'Це обов’язкове поле',
    notType: 'Невірний формат',
    defined: 'Поле має бути визначене',
    oneOf: 'Оберіть значення зі списку',
    notOneOf: 'Оберіть інше значення',
  },
  string: {
    email: 'Введіть коректну email-адресу',
    min: ({ min }) => `Мінімум ${min} символів`,
    max: ({ max }) => `Максимум ${max} символів`,
    length: ({ length }) =>
      `Має містити ${pluralize({
        count: length,
        one: 'символ',
        few: 'символи',
        many: 'символів',
      })}`,
    matches: 'Невірний формат',
  },
  number: {
    min: ({ min }) => `Мінімальне значення: ${min}`,
    max: ({ max }) => `Максимальне значення: ${max}`,
  },
  date: {
    min: ({ min }) => `Дата не може бути раніше ніж ${formatDate(min)}`,
    max: ({ max }) => `Дата не може бути пізніше ніж ${formatDate(max)}`,
  },
  array: {
    min: ({ min }) =>
      `Оберіть щонайменше ${pluralize({
        count: min,
        one: 'значення',
        few: 'значення',
        many: 'значень',
      })}`,
    max: ({ max }) =>
      `Оберіть не більше ${pluralize({
        count: max,
        one: 'значення',
        few: 'значення',
        many: 'значень',
      })}`,
    length: ({ length }) =>
      `Оберіть ${pluralize({
        count: length,
        one: 'значення',
        few: 'значення',
        many: 'значень',
      })}`,
  },
});
